import React, { useState, useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import withSource from "../../../../hocs/source-scoll";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getSensorsUrl } from "../../../../utils/sensor";
import deeplink from "../../../../../utils/deeplink";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const Image = withSource(props => {
	const { sensors, innerRef, position, trend } = props
    const { image, deepLink, refId } = trend;
	const { width, height, url: imageSrc } = image
	const aspectRatio = width && height ? `${width} / ${height}` : undefined

	let ratio
	if(width && height){
		ratio = `${Math.floor(height*100/width)}%`
	}


	const clickHandle = useCallback(e => {
		e.preventDefault()
		const href = e.currentTarget?.href
		window.location.href = getSensorsUrl(href, {
			resourcepage_title: sensors?.title,
			resource_type: sensors?.type,
			resource_content: refId,
			resource_position: `1-${position + 1}`,
		})
	}, []);

	return <a
		ref={innerRef}
		data-position={`1-${position + 1}`}
		data-type={sensors?.type}
		data-content={refId}
		data-title={sensors?.title}
		style={{
			width: "25%"
		}}
		onClick={clickHandle}
		href={deeplink(deepLink, "msite")}
    >
			<div className={`${cls.Image} ${!ratio?cls.Static:''}`} style={{
				aspectRatio,
				paddingTop: ratio,
			}}>
				<LazyLoadImage src={imageSrc} alt={refId} />
			</div>
	</a>
})

const ProductTrends = props =>{
    useStyles(cls);
    const { trends } = props;
    const global = useSelector(state =>state.global);
    const { config } = global;

    return <div className={cls.ProductTrends}>
        <div className={cls.Hd}>
            <span><FormattedMessage id="website_trends" defaultMessage="{website} trends" values={{ website: config?.name }} /></span>
        </div>

        <div className={cls.Bd}>
            {
                trends.trendItems.map((trend, index) =>(
                    <Image trend={trend} position={index} key={trend?.refId || index} sensors={{title:"product", type:"1"}} />
                ))
            }
        </div>
    </div>
}

export default ProductTrends;